import loadable from '@loadable/component';

export const EditJobPageContainerLoadable = loadable(
  () => import('./EditJobPageContainer'),
  {
    resolveComponent: (module) => module.EditJobPageContainer,
  },
);
